import { AlertMessage } from "../../../../../../common/data/AlertMsg";
import { TooltipMessage } from "../../../../../../common/data/TooltipMsg";
import { isEmptyArray, isTableDataAvailable } from "../../../../../../common/utils";
import InfoTab from "../../../../../../components/InfoTab";
import { AppInfoAction, sendAppInfoEvent } from "../../../../../../components/matomoClient";
import { AppInfoController } from "./controller";

export const AppInfoComponent = ({ appInfo, pageSize, setTabPageSize }) => {
  const {
    copyAOEmails,
    copyGaaEmails,
    gaaDataSource,
    aoDataSource,
    columns,
    isLoading,
    selectedColumns,
    totalColumns,
    setSelectedColumns,
    isErrorState,
  } = AppInfoController(appInfo);

  const noGaaMessage = "There are no Global Access Approvers";
  const noAoMessage = "There are no Access Owners";

  const GAA = "GAA";
  const AO = "AO";

  let modifiedColumns = columns;

  if (selectedColumns.length > 0) {
    modifiedColumns = columns?.filter(({ title }) => selectedColumns.includes(title));
  }

  function generalInfoProps() {
    let leftSideRenderElements = [];
    let rightSideRenderElements = [];
    const businessFunctions = {
      key: "business-functions",
      label: "Business functions",
      value: appInfo?.businessFunctions?.join(", "),
    };
    const applicationSupportEmail = {
      key: "application-support-email",
      label: "Application support email",
      value: appInfo?.gitsProductTeam?.email,
    };
    leftSideRenderElements.push(businessFunctions);
    rightSideRenderElements.push(applicationSupportEmail);
    return { leftSideRenderElements, rightSideRenderElements };
  }

  const generalInfo = generalInfoProps();

  function isTableLoading() {
    return isLoading !== null;
  }

  function copyAllEmailsMatomoFunction(role) {
    sendAppInfoEvent(AppInfoAction[`Copy${role}Emails`], appInfo?.name);
  }

  function getGlobalAccessApproversTableProps() {
    return {
      copyEmails: {
        copyEmailsList: copyGaaEmails,
        alertMessage: AlertMessage.copyAllEmails.applications[GAA],
        tooltipMessage: TooltipMessage.copyAllEmails[GAA],
        matomoFunction: () => {
          copyAllEmailsMatomoFunction(GAA);
        },
      },
      label: "Global access approvers",
      tableProps: {
        tableId: appInfo?.id,
        tableName: "appInfo-GAA",
        dataSource: gaaDataSource,
        columns: modifiedColumns,
        pagination: false,
      },
      noUserMessage: noGaaMessage,
    };
  }

  function getApplicationAccessOwnersProps() {
    return {
      copyEmails: {
        copyEmailsList: copyAOEmails,
        alertMessage: AlertMessage.copyAllEmails.applications[AO],
        tooltipMessage: TooltipMessage.copyAllEmails[AO],
        matomoFunction: () => {
          copyAllEmailsMatomoFunction(AO);
        },
      },
      label: "Access owners",
      tableProps: {
        tableId: appInfo?.id,
        tableName: "appInfo-AO",
        dataSource: aoDataSource,
        columns: modifiedColumns,
        pagination: {
          pageSize: pageSize,
          setTabPageSize: setTabPageSize,
        },
      },
      noUserMessage: noAoMessage,
    };
  }

  const listOfTables = [getGlobalAccessApproversTableProps(), getApplicationAccessOwnersProps()];

  function getColumnSelectProps() {
    return {
      shouldRender:
        !isEmptyArray(totalColumns) &&
        (isTableDataAvailable(aoDataSource) || isTableDataAvailable(gaaDataSource)),
      totalColumns,
      selectedColumns,
      onSelected: setSelectedColumns,
    };
  }

  return (
    <InfoTab
      isLoading={isTableLoading()}
      isErrorState={isErrorState}
      generalInfo={generalInfo}
      listOfTables={listOfTables}
      columnSelect={getColumnSelectProps()}
    />
  );
};
